<div class="tt-c-review-form">
  <form v-if="values.catItemId" class="tt-c-review-form__form tt-u-spacing--xl" @submit.prevent="submitForm">
    <tt-review-form-header :catItem="!isVisualFirst ? catItem : null"
      :siblingSiteKey="siblingSiteKey"
      :guidelinesOpen="guidelinesOpen"
      :hasGuidelines="true"
      :heading="heading"
      :eriCampaignMessage="eriCampaignMessage"
      :isEriCampaignActive="isEriCampaignActive"
      :description="$msg('revForm.feedbackText')"></tt-review-form-header>

    <tt-review-flow-product v-if="isVisualFirst"
      class="tt-c-review-form__item"
      :catItem="catItem"
      :forReviewForm="true"></tt-review-flow-product>

    <fieldset class="tt-u-spacing--lg">
      <tt-rating-stars-field
        v-model="values.rating"
        labelId="tt-review-form-rating"
        class="tt-c-review-form__overall-rating"
        :errorText="fieldErrors.rating"
        :label="$msg('revForm.rating')"
        :required="true">
      </tt-rating-stars-field>
      <tt-textarea id="tt-review-form-text"
                   name="tt-review-form-text"
                   aria-describedby="tt-review-form-text-hint"
                   class="tt-c-review-form__body-text"
                   :required="reviewSubmissionConfig.textRequired"
                   :label="$msg('revForm.textLabel')"
                   v-model="values.text"
                   :focusOnMount="false"
                   describedbyId="tt-review-form-text-hint"
                   :maxCharacters="fieldProperties.text.maxCharacters"
                   :hintText="$msg('revForm.textHint', [reviewSubmissionConfig.textMinLength])"
                   :errorText="fieldProperties.text.errorText"
                   rows="5"
      ></tt-textarea>
      <tt-text-field id="tt-review-form-title"
        class="tt-c-review-form__title"
        name="title"
        v-model="values.title"
        :errorText="fieldErrors.title"
        :hintText="$msg('revForm.titleHint', [reviewSubmissionConfig.titleMaxLength])"
        :label="$msg('revForm.titleLabel')"
        :required="reviewSubmissionConfig.titleRequired">
      </tt-text-field>

      <tt-review-dimension-fieldset
        class="tt-u-spacing--lg"
        v-model="dimensionsModel"
        :dimensionDefinitions="dimensionDefinitions"
        :dimensionErrors="dimensionErrors"></tt-review-dimension-fieldset>

      <tt-check-group
        v-if="reviewSubmissionConfig.showRecommend"
        v-model="values.recommend"
        id="tt-review-form-recommend"
        class="tt-c-review-form__recommend"
        :errorText="fieldErrors.recommend"
        :label="$msg('revForm.wouldRecommend')"
        groupName="recommend"
        displayType="icon"
        :fields="recommendFields"
        :required="reviewSubmissionConfig.recommendRequired"></tt-check-group>

      <tt-added-media v-if="globalConfig.mediaEnabled"
        class="tt-c-review-form__added-media"
        @addPhotos="addPhotos"
        @addVideo="addVideo"
        :forReviewForm="true"
        :label="$msg('revForm.media')"
        :errorText="fieldErrors.media"></tt-added-media>

      <tt-shopper-profile-fieldset v-if="profileDefinitions"
        class="tt-u-spacing--lg"
        v-model="shopperProfileModel"
        :ageRange="profileDefinitions.ageRange"
        :location="profileDefinitions.location"
        :customAttributes="profileDefinitions.customAttributes"
        :profileErrors="profileErrors">
      </tt-shopper-profile-fieldset>

      <tt-check-group
        v-if="reviewSubmissionConfig.showSweepstakes && !values.incentiveType"
        v-model="values.sweepstakesOptIn"
        class="tt-c-review-form__sweepstakes"
        groupName="tt-review_sweepstakes"
        displayType="checkbox"
        :fields="[{ label: $msg('revForm.sweepstakes'), value: true, id: 'tt-review-sweepstakes' }]">
      </tt-check-group>

      <tt-check-group
        v-if="reviewSubmissionConfig.acceptTermsRequired"
        v-model="values.acceptedTerms"
        class="tt-c-review-form__accept-terms"
        groupName="tt-review_accept-terms"
        displayType="checkbox"
        :fields="[{ label: $msg('revForm.acceptedTerms', [reviewSubmissionConfig.termsUrl]), id: 'tt-review-accept-terms' }]"
        :required="true"
        :errorText="fieldErrors.acceptedTerms">
      </tt-check-group>

      <p v-if="$msg('revForm.disclaimer')" class="tt-c-review-form__disclaimer" v-html="$msg('revForm.disclaimer')"></p>

      <div class="tt-c-review-form__actions">
        <tt-button v-show="!isSubmitting" type="primary" @click="submit" class="tt-c-review-form__submit" v-html="$msg('revForm.submit')"></tt-button>
        <div v-show="isSubmitting" class="tt-o-spinner tt-o-spinner--submit"></div>
        <a v-show="!isSubmitting && isVisualFirst" href="#" class="tt-c-review-form__no-thanks" @click.prevent="skip" @keydown.enter.prevent="skip" rel="nofollow" v-html="$msg('revForm.noThanks')"></a>
      </div>
    </fieldset>

  </form>
</div>
